var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.fixedStepIndex,"align-center":""}},[_vm._l((_vm.steps),function(step,index){return [_c('el-step',{key:step.title,attrs:{"status":_vm.stepStatus(index, _vm.steps),"title":step.title}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }